export const BUTTON_NO_NAME =
	'Button components must always have a valid accessible name.' +
	' This can be provided via children or an ARIA name.' +
	' See https://www.w3.org/WAI/ARIA/apg/practices/names-and-descriptions/ for more details.';
